import { t } from '../../localization';
import planFeaturesGroupIds from '../constants/plan-features-gruop-ids';

const getFeatureGroups = (isB2C) => [
  {
    id: planFeaturesGroupIds.CORE,
    title: t('Core'),
    data: [],
  },
  {
    id: planFeaturesGroupIds.MARKETING,
    title: t('Marketing'),
    data: [],
  },
  {
    id: planFeaturesGroupIds.AI,
    title: isB2C ? t('Yola AI') : t('AI'),
    data: [],
  },
  {
    id: planFeaturesGroupIds.SEO,
    title: t('SEO'),
    data: [],
  },
  {
    id: planFeaturesGroupIds.SECURITY,
    title: t('Security'),
    data: [],
  },
  {
    id: planFeaturesGroupIds.MORE,
    title: t('More'),
    data: [],
  },
];

export default getFeatureGroups;
